import { render, staticRenderFns } from "./CaptureProfiles.vue?vue&type=template&id=88d6b40a&scoped=true&"
import script from "./CaptureProfiles.vue?vue&type=script&lang=js&"
export * from "./CaptureProfiles.vue?vue&type=script&lang=js&"
import style0 from "./CaptureProfiles.vue?vue&type=style&index=0&id=88d6b40a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d6b40a",
  null
  
)

export default component.exports